/**
 * The navigation model, in one place, so the desktop rail and the mobile bar
 * can never drift apart.
 */
import type { ComponentType } from 'react'
import {
  ArrowLeftRightIcon,
  BellIcon,
  ChartLineIcon,
  CreditCardIcon,
  FilterIcon,
  LayoutDashboardIcon,
  RepeatIcon,
  SettingsIcon,
  SparklesIcon,
  TargetIcon,
  TrendingUpIcon,
  WalletIcon,
} from 'lucide-react'

export interface NavItem {
  label: string
  to: string
  icon: ComponentType<{ className?: string; 'aria-hidden'?: boolean }>
  /** Matches the route exactly rather than by prefix. Only the dashboard needs it. */
  end?: boolean
  /**
   * Shown in the mobile bottom bar. Ten icons do not fit at 375px, so the rest
   * live behind "More".
   */
  primary?: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboardIcon, end: true, primary: true },
  { label: 'Accounts', to: '/accounts', icon: WalletIcon, primary: true },
  { label: 'Transactions', to: '/transactions', icon: ArrowLeftRightIcon, primary: true },
  { label: 'Subscriptions', to: '/subscriptions', icon: RepeatIcon },
  { label: 'Budgets', to: '/budgets', icon: TargetIcon },
  { label: 'Analytics', to: '/analytics', icon: ChartLineIcon },
  { label: 'Investments', to: '/investments', icon: TrendingUpIcon },
  { label: 'Debt', to: '/debt', icon: CreditCardIcon, primary: true },
  { label: 'Alerts', to: '/alerts', icon: BellIcon, primary: true },
  // Insights and Rules are full screens with routes of their own. Without a
  // rail entry the only way in was a link buried in Settings and one in the
  // AI panel's footer — a screen you can only reach by accident.
  { label: 'Insights', to: '/insights', icon: SparklesIcon },
  { label: 'Rules', to: '/rules', icon: FilterIcon },
  { label: 'Settings', to: '/settings', icon: SettingsIcon },
]

export const PRIMARY_NAV_ITEMS = NAV_ITEMS.filter((item) => item.primary)
export const SECONDARY_NAV_ITEMS = NAV_ITEMS.filter((item) => !item.primary)
